export const habaCountries = {
  countries: {
    AL: 'Albanien',
    AD: 'Andorra',
    BE: 'Belgien',
    BA: 'Bosnien und Herzegowina',
    BG: 'Bulgarien',
    DE: 'Deutschland',
    DK: 'Dänemark',
    EE: 'Estland',
    FI: 'Finnland',
    FR: 'Frankreich',
    FO: 'Färöer Inseln',
    GI: 'Gibraltar',
    GR: 'Griechenland',
    GL: 'Grönland',
    VA: 'Heiliger Stuhl (Staat Vatikanstadt)',
    IE: 'Irland',
    IS: 'Island',
    IT: 'Italien',
    HR: 'Kroatien',
    LV: 'Lettland',
    LI: 'Liechtenstein',
    LT: 'Litauen',
    LU: 'Luxemburg',
    MT: 'Malta',
    MK: 'Mazedonien',
    MD: 'Moldawien',
    MC: 'Monaco',
    ME: 'Montenegro',
    NL: 'Niederlande',
    NO: 'Norwegen',
    PL: 'Polen',
    PT: 'Portugal',
    RO: 'Rumänien',
    RU: 'Russische Föderation',
    SM: 'San Marino',
    SE: 'Schweden',
    CH: 'Schweiz',
    RS: 'Serbien',
    SK: 'Slowakei',
    SI: 'Slowenien',
    ES: 'Spanien',
    CZ: 'Tschechien',
    TR: 'Türkei',
    UA: 'Ukraine',
    HU: 'Ungarn',
    BY: 'Weißrussland',
    CY: 'Zypern',
    AT: 'Österreich',
  },
  languages: {
    en: 'Englisch',
    de: 'Deutsch',
    ch: 'Schweizerisch',
    fr: 'Französisch',
  },
};
